'use strict';

angular.module('webAgro1App').factory('AspectosGeraisService', function($http) {
  return {
    updateCultivar: function (aspecto_geral, cultivar) {
      const dados = {
        aspecto_geral: {
          cultivar_id: cultivar.item_id
        }
      };
      const url = `${SERVER}${API_VERSION}aspectos_gerais/${aspecto_geral.sincId}/update_cultivar`;

      return $http({
        method: 'PATCH',
        headers: {'Content-Type': 'application/json'},
        url: url,
        data: dados
      });
    }
  }
});
